// Draws the p5.js logo
export function drawSpinningLogo(x, y, t, c) {
  push();
  translate(x, y);
  scale(0.75);
  rotate(radians(t * 6.5));
  translate(-14, -14);
  noStroke();
  fill(c || '#ED225D');
  beginShape();
  vertex(16.909, 10.259);
  vertex(25.442, 7.683);
  vertex(27.118, 12.839);
  vertex(18.62, 15.738);
  vertex(23.895, 23.218);
  vertex(19.448, 26.443);
  vertex(13.895, 19.095);
  vertex(8.487, 26.25);
  vertex(4.169, 22.961);
  vertex(9.444, 15.738);
  vertex(0.88, 12.647);
  vertex(2.558, 7.487);
  vertex(11.156, 10.258);
  vertex(11.156, 1.364);
  vertex(16.91, 1.364);
  endShape(CLOSE);
  pop();
}
